/* eslint-disable camelcase */
import React, { useState, useRef } from 'react';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import { Tabs, Tab } from '@material-ui/core';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import ScanQR from 'src/assets/images/ScanQR.svg';
import InputBox from 'src/common/refactoredComponents/input/Input';
import ScanBardCodePopUp from './ScanBardCodePopUp.jsx';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'src/api/Api';
import NotAbleToReceiveSets from '../notifications/NotAbleToReceiveSets.jsx';
import AutoListItem from 'src/pages/receiveSets/components/common/AutoListItem/AutoListItem';
import AutoListBatchItem from 'src/pages/receiveSets/components/common/AutoListItem/AutoListItem';
import InputView from 'src/pages/receiveSets/components/common/InputView/InputView';
import InputBatchView from 'src/pages/receiveSets/components/common/InputView/InputView';
import AutoComplete from 'src/common/refactoredComponents/form/autocomplete/AutoComplete.jsx';
import ReportAutoBatchComplete from 'src/pages/reportUsage/common/autoComplete/ReportAutoComplete';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import { ButtonsContainer } from 'src/pages/scheduleSurgery/components/cart/quickOrder/QuickOrder.styled.jsx';
import { debounce, isIpad, isMobileView, logErrorToConsole } from 'src/utils/util.js';
import {
    AddSetContainer,
    AddSetScan,
    AddSetManually,
    MainContainerItems,
    Title,
    TabContainer,
    ButtonContainer,
    TextBold,
    SuccessMsg,
    ErrorMessage,
    TextArea,
    StyledDiv,
    TextAreaContainer,
} from './index.styled';
import {
    getProductDetails,
    searchProducts,
    getBarcodeReceiveSets,
    checkIsOutsideTerritory,
    saveSetsOutsideTerritoryList,
    resetCreateReceiveSets,
    resetBarcodeDetails,
    showInvalidBarcodePoup,
    SetNumberSelected,
    BatchNumberSelected,
    resetInvalidBarCodeDetails,
    showDChainStatusPopup,
    createReceiveSetsFailure,
    dChainBarCodeDetails,
    invalidBarCodeDetails,
    bulkEXcludedPopupData,
    ResetBulkEXcludedPopupData,
    resetBulkBarcodeDetailsData,
    resetBulkEXcludedPopupData,
} from 'src/pages/receiveSets/redux/actions';
import ExternalCamera from '../notifications/ExternalCamera.jsx';
import InvalidBarcodePopup from '../notifications/InvalidBarcodePopup.jsx';
import { useTranslation } from 'react-i18next';
import UnsavedChanges from '../notifications/UnsavedChanges.jsx';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
//import { searchProducts } from 'src/pages/equity/redux/actions';

// import SetSearch from './SetSearch.jsx';
export default function AddSetsLists({
    territoryId,
    accountId,
    setSetFieldFocus,
    counterMessage,
    setCounterMessage,
    setIsBulkAdd,
}) {
    const { t } = useTranslation();
    const [counter, setCounter] = useState(0);
    const [expandedCard, setExpandedCard] = useState({
        receive_location: true,
        add_set_scan: false,
        add_set_manually: false,
    });
    const [setNumber, updateSetNumber]=useState('');
    const [scanBarCode, setScanBarCode] = useState(false);
    const [success, setSuccess] = useState(false);
    const [, setSetNo] = useState('');
    const [barcodeNo, setBarcodeNo] = useState('');
    const [batchNo, setBatchNo] = useState('');
    const [axiosSource, setAxiosSource] = useState(axios.CancelToken.source());
    const [, setFromManual] = useState(false);
    const [popupDetails, setPopupDetails] = useState({
        showDiscardPopup: false,
        id: null,
    });
    const { showDiscardPopup } = popupDetails;
    const openDiscardPopup = (id) => {
        setPopupDetails({ ...popupDetails, showDiscardPopup: true, id: id });
    };
    const handleDiscardChanges = () => {
        setPopupDetails({ ...popupDetails, showDiscardPopup: false, id: null });
        //clearing the data
        setBulkValues('');
        resetPosition();
    };
    var arr = [];

    const { isLanguageChanged } = useSelector((state) => state.loginReducer);
    const productsList = useSelector(
        (state) => state.receiveSetsProductsSearchReducer.products
    );
    const productsListLoading = useSelector(
        (state) => state.receiveSetsProductsSearchReducer.loading
    );
    const productsDetails = useSelector(
        (state) => state.receiveSetsProductDetailsReducer?.data?.batches
    );
    const obj = Object.assign({}, productsDetails && productsDetails);
    arr.push(obj);
    let result = Object.keys(obj).map((key) => ({
        batchNo: obj[key],
        cfn: obj[key],
    }));
    const productsDetailsLoading = useSelector(
        (state) => state.receiveSetsProductDetailsReducer.loading
    );
    const receiveSetsLoading = useSelector(
        (state) => state.createReceiveSetsReducer.receiveSetsLoading
    );
    const setsList = useSelector(
        (state) => state.receiveSetsListDataReducer.receiveSetsListData
    );
    const isOutsideTerritory = useSelector(
        (state) => state.receiveSetsListDataReducer.isOutsideTerritory
    );
    const setsOutsideTerritoryList = useSelector(
        (state) => state.receiveSetsListDataReducer.setsOutsideTerritoryList
    );
    const showInvalidBarcode = useSelector(
        (state) => state.receiveSetsListDataReducer.showInvalidBarcodePopup
    );
    const showDChainStatusPopups = useSelector(
        (state) => state.receiveSetsListDataReducer.showDChainStatusPopup
    );
    const invalidBarcodeDetailsData = useSelector(
        (state) => state.receiveSetsListDataReducer.invalidBarcodeDetails
    );
    const dChainBarCodeDetailsData = useSelector(
        (state) => state.receiveSetsListDataReducer.dchainBarcodes
    );
    const validatedData = useSelector(
        (state) => state.createReceiveSetsReducer.createReceiveSets
    );
    const barcodeDetails = useSelector(
        (state) => state.receiveSetsListDataReducer.barcodeDetails
    );
    const bulkExcludedData = useSelector(
        (state) => state.receiveSetsListDataReducer.bulkExcludedData
    );

    // const [invalidDchainBarcodePopup, setInvalidDchainBarcodePopup] = useState([]);
    // const [inValidBarcodePopup, setInValidBarcodePopup] = useState([]);
    // const [dchainPopup, setDchainPopup] = useState([]);
    const [notAbleToReceivePopup, setNotAbleToReceivePopup] = useState([]);
    const [bulkPopupData, setBulkPopupData] = useState([]);
    const [bulkPopups, setBulkPopups] = useState([]);
    const [isBulkDchainAdd, setIsBulkDchainAdd] = useState(false);
    // const [isInvalidBarcode, setIsInvalidBarcode] = useState(false);

    const getUniqueBulkExcluded = [
        ...new Map(
            bulkExcludedData?.map((item) => [item['barcode'], item])
        ).values(),
    ];

    const [invalidAndDchainBarcode, setInvalidAndDchainBarcode] = useState([]);
    const setNumberRef = useRef(null);
    const batchRef = useRef(null);
    const [batchNum,setBatchNum]=useState('');
    useEffectWithErrorLogging(() => {
        if (
            invalidBarcodeDetailsData.length > 0 ||
            dChainBarCodeDetailsData.length > 0
        ) {
            setInvalidAndDchainBarcode([
                ...invalidBarcodeDetailsData,
                ...dChainBarCodeDetailsData,
            ]);
        }
    }, [invalidBarcodeDetailsData, dChainBarCodeDetailsData]);

    const getUniqueInvalidAndDchainBarcode = [
        ...new Map(
            invalidAndDchainBarcode?.map((item) => [
                item['barCodeNumber'],
                item,
            ])
        ).values(),
    ];

    const isInvalidInList =
        barcodeDetails?.length > 0
            ? barcodeDetails?.some((item) => item.statusCode === '10001')
            : null;

    useEffectWithErrorLogging(() => {
        if (
            (validatedData?.statusCode === '10830' ||
                validatedData?.statusCode === '10734' ||
                validatedData?.statusCode === '11617') &&
            isInvalidInList
        ) {
            setBulkPopupData([
                ...getUniqueInvalidAndDchainBarcode,
                ...getUniqueBulkExcluded,
            ]);
        } else if (!isInvalidInList) {
            setBulkPopupData([...getUniqueInvalidAndDchainBarcode]);
        }
    }, [validatedData, invalidAndDchainBarcode]);

    useEffectWithErrorLogging(() => {
        if (bulkPopupData.length > 0) {
            setBulkPopups([bulkPopupData[0]]);
        }
    }, [bulkPopupData]);

    // console.log('invalidDchainBarcodePopup', invalidDchainBarcodePopup);
    // useEffectWithErrorLogging(() => {
    //     if (invalidBarcodeDetailsData.length > 0) {
    //         setInValidBarcodePopup([invalidBarcodeDetailsData[0]]);
    //         setIsInvalidBarcode(true);
    //     }
    // }, [invalidBarcodeDetailsData]);

    // useEffectWithErrorLogging(() => {
    //     if (dChainBarCodeDetailsData.length > 0) {
    //         setDchainPopup([dChainBarCodeDetailsData[0]]);
    //     }
    // }, [dChainBarCodeDetailsData]);

    // useEffectWithErrorLogging(() => {
    //     if (
    //         validatedData?.statusCode === '10830' ||
    //         validatedData?.statusCode === '10734'
    //     ) {
    //         setNotAbleToReceivePopup([bulkExcludedData[0]]);
    //     }
    // }, [validatedData]);
    // const changeInvalidDhcainState = (barcode) => {
    //     setInvalidDchainBarcodePopup([]);
    //     setInvalidDchainBarcodePopup([barcode]);
    // };

    const changeBulkPopupState = (barcode) => {
        setBulkPopups([]);
        setBulkPopups([barcode]);
    };

    // const changeState = (barcode) => {
    //     setInValidBarcodePopup([]);
    //     setInValidBarcodePopup([barcode]);
    // };

    // const dChainChangeState = (barcode) => {
    //     setDchainPopup([]);
    //     setDchainPopup([barcode]);
    // };
    // console.log('dchainPopup', dchainPopup);

    // const notAbleToReceiveState = (barcode) => {
    //     setNotAbleToReceivePopup([]);
    //     setNotAbleToReceivePopup([barcode]);
    // };

    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };
    const [showNotificationPopup, setShowNotificationPoup] = useState(false);
    const [cursorOnInput, setCursorOnInput] = useState(false);
    const [value, setValue] = useState('1');
    const [manualValue, setManualValue] = useState('3');
    const [open, setOpen] = useState(false);
    const [batch, setBatchOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState('');
    const [selectedBatchProduct, setSelectedBatchProduct] = useState('');
    const [selectedProductDesc, setSelectedProductDesc] = useState('');
    const [isAdded, setIsAdded] = useState(false);
    const [batchAdded, setBatchAdded] = useState(false);
    const [salesOrg, setSalesOrg] = useState('S002');
    const [, setBatchNumber] = useState('');
    const [, setSetNumber] = useState('');
    const [showExteralCameraPopup, setShowExteralCameraPopup] = useState(false);
    const [showBulkAdd, setShowBulkAdd] = useState(false);
    const [editableHeight, setEditableHeight] = useState('');
    const [bulkValues, setBulkValues] = useState('');
    const [setOrItemNumbers, setSetOrItemNumbers] = useState([]);
    const [
        showSuccessMessageInScannerScreen,
        setShowSuccessMessageInScannerScreen,
    ] = useState(false);
    const [dChainCrossPlantStatus, setDChainCrossPlantStatus] = useState(false);
    const [
        showSuccessMessageExternalScanner,
        setShowSuccessMessageExternalScanner,
    ] = useState(false);
    const [externalBarcodeInputValue, setExternalBarcodeInputValue] = useState('');
    const externalBarcodeInputRef = useRef(null);
    const dispatch = useDispatch();
    
    const clearExternalBarcodeField = () => {
        setExternalBarcodeInputValue('');
        if (externalBarcodeInputRef.current) {
            externalBarcodeInputRef.current.value = '';
        }
        const inputElement = document.getElementById('receivesets-addsetslists-external-barcode-input');
        if (inputElement) {
            inputElement.value = '';
        }
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (newValue == '2') {
            setCursorOnInput(true);
        }
    };
    const handleManualTabChange = (event, newValue) => {
        setManualValue(newValue);
        if (newValue === '4') {
            setOpen(false);
            setSelectedProduct('');
            dispatch(SetNumberSelected(''));
            setSetNumber('');
            setSelectedBatchProduct('');
            dispatch(BatchNumberSelected(''));
            setBatchNumber('');
            setBatchAdded(!batchAdded);
            updateSetNumber('');
            setBatchNum('');
        } else if (newValue === '3') {
            setBarcodeNo('');
        } else if (newValue === '5') {
            setShowBulkAdd(true);
            setBarcodeNo('');
            setSelectedProduct('');
            dispatch(SetNumberSelected(''));
            setSetNumber('');
            setSelectedBatchProduct('');
            dispatch(BatchNumberSelected(''));
            setBatchNumber('');
            setBatchAdded(!batchAdded);
            updateSetNumber('');
            setBatchNum('');
        }
    };
    const resetPosition = () => {
        setEditableHeight('');
        setTimeout(() => {
            try {
            if (isMobileView() || isIpad()) {
                document.getElementById('popUpContent').style.position = '';
                document.getElementById('popUpContent').style.top = '';
            }
             } catch (error) {
                   logErrorToConsole(error);
                }
        }, 0);
    };
    // this method extracts the text from clipboard and sets the text to text area
    const copyToClipBoard = () => {
        navigator.clipboard
            .readText()
            .then((result) => {
                const finalResult = bulkValues.length
                    ? `${bulkValues}\n ${result}`
                    : result;
                setBulkValues(finalResult);
            })
            .catch((error) => {
                logErrorToConsole('something went wrong', error);
            });
    };
    const handleBarcodeInput = (e) => {
        setBarcodeNo(e.target.value);
    };
    const selectedSetNumber = useSelector(
        (state) => state.receiveSetsListDataReducer.selectedSetNumber
    );
    const selectedBatchNumber = useSelector(
        (state) => state.receiveSetsListDataReducer.selectedBatchNumber
    );
    const showErrorPopupMessage = useSelector(
        (state) => state.createReceiveSetsReducer.showErrorPopupMessage
    );
    const showSuccessPopupMessage = useSelector(
        (state) => state.receiveSetsListDataReducer.showSuccessPopupMessage
    );

    const ref = useRef(null);

    // useEffectWithErrorLogging(() => {
    //     //debugger
    //     if (document.activeElement === ref.current) {
    //       console.log('element has focus');
    //     } else {
    //       console.log('element does NOT have focus');
    //     }
    //   }, []);

    // useEffectWithErrorLogging(() => {
    //     if (barcodeDetails.statusCode === '10001') {
    //         let newArray = [];
    //         let newObj = [];
    //         newObj = [
    //             {
    //                 setNo: barcodeDetails?.setNumber,
    //                 batchNo: barcodeDetails?.batchNumber,
    //                 accountId: accountId,
    //                 isBarCode: fromManual ? false : true,
    //                 territoryId: territoryId,
    //                 description: barcodeDetails?.description,
    //                 accountCode: barcodeDetails?.accountCode,
    //                 accountName: barcodeDetails?.accountName,
    //             },
    //         ];

    //         const isFound = receiveSetsListData?.some((element) => {
    //             if (element.batchNo == barcodeDetails.batchNumber) {
    //                 return true;
    //             }
    //         });
    //         console.log('isFound', isFound);
    //         if (isFound === true) {
    //             setErrorMessage(true);
    //             newArray = [...receiveSetsListData];
    //         } else {
    //             setErrorMessage(false);
    //             newArray = [...receiveSetsListData, ...newObj];
    //         }
    //         setTimeout(() => setErrorMessage(false), 2000);
    //         console.log('NEWArrayinscandit', newArray);
    //         let setsPayload = [
    //             {
    //                 batchNo: barcodeDetails.batchNumber,
    //                 isBarCode: fromManual ? false : true,
    //                 setNo: barcodeDetails.setNumber,
    //             },
    //         ];

    //         const payload = {
    //             accountId: accountId.accountId,
    //             sets: setsPayload,
    //             territoryId: territoryId,
    //             isSubmit: false,
    //             dataList: newArray,
    //         };
    //         console.log('payloadofvalidation', payload);
    //         dispatch(createReceiveSets(payload));
    //         setFromManual(false);
    //     }
    // }, [barcodeDetails]);

    // const handleCounterMessage = (counterMessageFlag) => {
    //     setCounterMessage(counterMessageFlag);
    // };

    const handleAddBarcodeToList = () => {
        setIsBulkDchainAdd(false);
        setShowSuccessMessageInScannerScreen(true);
        setShowSuccessMessageExternalScanner(false);
        // dispatch(
        //     checkIsOutsideTerritory({
        //         batchNumber: selectedBatchProduct,
        //         setNumber: selectedProduct,
        //         territoryId: territoryId,
        //         accountId: accountId,
        //         description: selectedProductDesc,
        //         barcode: barcodeNo,
        //         isManual: true,
        //     })
        // );
        setFromManual(true);

        dispatch(
            getBarcodeReceiveSets({
                territoryId: territoryId,
                accountId: accountId,
                barcode: barcodeNo?.trim().replace(/,/g, ''),
                isManual: true,
                isBulkAdd: false,
                // isBarCode: true,
            })
        );
        setBarcodeNo('');
        dispatch(resetCreateReceiveSets());
        setIsBulkAdd(false);
    };

    const addBulkToList = () => {
        setIsBulkDchainAdd(true);
        let setOrItemNumbers = [];
        let setOrItemNumbersFinal = [];
        if (!!bulkValues && bulkValues.includes('\n')) {
            setOrItemNumbers = bulkValues
                .split('\n')
                .map((element) => element.replace(/[\r\n]+/gm, '').trim())
                .filter((item) => item.length > 0);
            setOrItemNumbers.forEach((item) => {
                setOrItemNumbersFinal = [
                    ...setOrItemNumbersFinal,
                    ...item
                        .split(',')
                        .map((ele) => ele.trim())
                        .filter((item) => item.length > 0),
                ];
            });
            setSetOrItemNumbers(setOrItemNumbersFinal);
        } else if (bulkValues.includes(',')) {
            setOrItemNumbersFinal = bulkValues
                .split(',')
                .map((element) => element.trim())
                .filter((item) => item.length > 0);
            setSetOrItemNumbers(setOrItemNumbersFinal);
        } else if (bulkValues.length) {
            setOrItemNumbersFinal = bulkValues
                .split(',')
                .map((item) => item.trim());
            setSetOrItemNumbers(setOrItemNumbersFinal);
        } else {
            return;
        }
        setShowSuccessMessageInScannerScreen(true);
        setShowSuccessMessageExternalScanner(false);
        setFromManual(true);

        dispatch(
            getBarcodeReceiveSets({
                territoryId: territoryId,
                accountId: accountId,
                barcode: setOrItemNumbersFinal,
                isManual: true,
                // isBarCode: true,
                isBulkAdd: true,
                isInvalid: false,
            })
        );
        setBulkValues('');
        dispatch(resetCreateReceiveSets());
        dispatch(resetInvalidBarCodeDetails());
        setShowBulkAdd(false);
        setIsBulkAdd(true);
    };

    const handleAddSetsToList = () => {
        setBatchNum('');
        updateSetNumber('');
        setShowSuccessMessageInScannerScreen(true);
        setShowSuccessMessageExternalScanner(false);
        dispatch(
            checkIsOutsideTerritory({
                batchNumber: selectedBatchProduct,
                setNumber: selectedProduct,
                territoryId: territoryId,
                accountId: accountId,
                description: selectedProductDesc,
                isSetAndBatch: true,
            })
        );
        setSetNo('');
        setIsAdded(!isAdded);
        setBatchAdded(!batchAdded);
        setOpen(false);
        setBatchOpen(false);
        setSelectedProduct('');
        dispatch(SetNumberSelected(''));
        setSelectedBatchProduct('');
        dispatch(BatchNumberSelected(''));
        setBatchNumber('');
        setSetNumber('');
        setSetFieldFocus(false);
    };

    useEffectWithErrorLogging(() => {
        if (
            (validatedData?.statusCode === '10830' ||
                validatedData?.statusCode === '10734') &&
            validatedData?.isManual !== undefined
        ) {
            setsOutsideTerritoryList.pop();
            isBulkDchainAdd
                ? setShowNotificationPoup(false)
                : setShowNotificationPoup(true);
            setSelectedProduct('');
            dispatch(SetNumberSelected(''));
            setSetNumber('');
            setSelectedBatchProduct('');
            dispatch(BatchNumberSelected(''));
            setBatchNumber('');
            setBatchAdded(!batchAdded);
            if (showSuccessMessageExternalScanner) {
                clearExternalBarcodeField();
            }
        } else if (
            validatedData?.statusCode === '11617' &&
            !validatedData?.isFoundDuplicate
        ) {
            setShowNotificationPoup(false);
            setSuccess(true);
            setTimeout(() => {
                try {
                setSuccess(false);
                setShowSuccessMessageInScannerScreen(false);
                 } catch (error) {
                   logErrorToConsole(error);
                }
            }, 2000);
            setSelectedProduct('');
            dispatch(SetNumberSelected(''));
            setSetNumber('');
            setSelectedBatchProduct('');
            dispatch(BatchNumberSelected(''));
            setBatchNumber('');
            setBatchAdded(!batchAdded);
            if (showSuccessMessageExternalScanner) {
                clearExternalBarcodeField();
            }
        } else if (
            validatedData?.statusCode === '11617' &&
            validatedData?.isFoundDuplicate
        ) {
            setsOutsideTerritoryList.pop();
            setShowSuccessMessageInScannerScreen(false);
            setSelectedProduct('');
            dispatch(SetNumberSelected(''));
            setSetNumber('');
            setSelectedBatchProduct('');
            dispatch(BatchNumberSelected(''));
            setBatchNumber('');
            setBatchAdded(!batchAdded);
            if (showSuccessMessageExternalScanner) {
                clearExternalBarcodeField();
            }
        } else if (
            validatedData?.statusCode === '11911' &&
            !validatedData?.isFromScanner
        ) {
            setDChainCrossPlantStatus(true);
        }
    }, [validatedData]);

    useEffectWithErrorLogging(() => {
        if (isOutsideTerritory?.isSetOutsideTerritory === true) {
            let newObj;
            let newArray;
            newObj = [
                {
                    // setNumber: isOutsideTerritory.setNumber,
                    // batchNumber: isOutsideTerritory.batchNumber,
                    barcode: isOutsideTerritory.barcode,
                    accountName: isOutsideTerritory.accountName,
                    accountCode: isOutsideTerritory.accountCode,
                },
            ];

            if (setsOutsideTerritoryList && setsOutsideTerritoryList.length > 0)
                newArray = [...setsOutsideTerritoryList, ...newObj];
            else newArray = [...newObj];
            // setsOutsideTerritoryList.push(newObj);
            const getUniqueArray = [
                ...new Map(
                    newArray.map((item) => [item['barcode'], item])
                ).values(),
            ];
            dispatch(saveSetsOutsideTerritoryList(getUniqueArray));
            setIsAdded(!isAdded);
            setBatchAdded(!batchAdded);
            setBatchNo('');
        }
    }, [isOutsideTerritory]);
    // useEffectWithErrorLogging(() => {
    //     dispatch(
    //         getProductDetails({
    //             productCFN: setNo,
    //             salesOrg: 'S002',
    //         })
    //     );
    // }, [receiveSetsListData]);

    const handleOnOpen = () => {
        if (selectedProduct.length > 2) setOpen(true);
    };
    const handleBatchOnOpen = () => {
        if (selectedProduct.length > 0 && result?.length > 0) {
            setBatchOpen(true);
        }
    };
    const popupClose = () => {
        dispatch(showInvalidBarcodePoup(false));
        setDChainCrossPlantStatus(false);
        dispatch(showDChainStatusPopup(false));
        dispatch(createReceiveSetsFailure(false));
        localStorage.removeItem('createReceiveSetError');
        setCursorOnInput(true);
        if (showSuccessMessageExternalScanner) {
            document.getElementById('receivesets-addsetslists-external-barcode-input').value = '';
            document.getElementById('receivesets-addsetslists-external-barcode-input').focus();
        }
    };

    const bulkPopupClose = () => {
        const temp = bulkPopupData.shift();
        const getUniqueListBy = [
            ...new Map(
                bulkPopupData.map((item) => [
                    item['barCodeNumber' || 'barcode'],
                    item,
                ])
            ).values(),
        ];
        const filteredBarcode = bulkPopupData.filter(
            (item) =>
                (item.barCodeNumber || item.barcode) !==
                (bulkPopups[0].barCodeNumber || bulkPopups[0].barcode)
        );

        if (filteredBarcode?.length > 0) {
            changeBulkPopupState(filteredBarcode[0]);
        } else {
            setBulkPopups([]);
            dispatch(invalidBarCodeDetails([]));
            dispatch(dChainBarCodeDetails([]));
            setInvalidAndDchainBarcode([]);
            dispatch(resetBulkEXcludedPopupData([]));
            dispatch(resetBulkBarcodeDetailsData([]));
            dispatch(resetCreateReceiveSets());
            localStorage.removeItem('createReceiveSetError');
        }

        setCursorOnInput(true);
        if (showSuccessMessageExternalScanner) {
            document.getElementById('receivesets-addsetslists-external-barcode-input').value = '';
            document.getElementById('receivesets-addsetslists-external-barcode-input').focus();
        }
    };

    // const invalidAndDchainClose = () => {
    //     const temp = invalidAndDchainBarcode.shift();
    //     const filteredBarcode = invalidAndDchainBarcode.filter(
    //         (item) =>
    //             item.barCodeNumber !== invalidDchainBarcodePopup[0].barCodeNumber
    //     );
    //     console.log('temp', temp);
    //     console.log('filteredBarcode', filteredBarcode);

    //     if (filteredBarcode?.length > 0) {
    //         changeInvalidDhcainState(filteredBarcode[0]);
    //     } else {
    //         setInvalidDchainBarcodePopup([]);
    //         dispatch(invalidBarCodeDetails([]));
    //         dispatch(dChainBarCodeDetails([]));
    //     }

    //     setCursorOnInput(true);
    //     if (showSuccessMessageExternalScanner) {
    //         document.getElementById('receivesets-addsetslists-external-barcode-input').value = '';
    //         document.getElementById('receivesets-addsetslists-external-barcode-input').focus();
    //     }
    // };

    // const bulkPopupClose = () => {
    //     // localStorage.removeItem('createReceiveSetError');
    //     const temp = invalidBarcodeDetailsData.shift();
    //     const filterTemp = invalidBarcodeDetailsData.filter(
    //         (item) =>
    //             item.barCodeNumber !== inValidBarcodePopup[0].barCodeNumber
    //     );
    //     console.log('temp', temp);
    //     changeState(filterTemp[0]);

    //     if (filterTemp?.length > 0) {
    //         changeState(filterTemp[0]);
    //     } else {
    //         dispatch(invalidBarCodeDetails([]));
    //         setInValidBarcodePopup([]);
    //     }

    //     setCursorOnInput(true);
    //     if (showSuccessMessageExternalScanner) {
    //         document.getElementById('receivesets-addsetslists-external-barcode-input').value = '';
    //         document.getElementById('receivesets-addsetslists-external-barcode-input').focus();
    //     }
    // };
    // const bulkDchainPopupClose = () => {
    //     // localStorage.removeItem('createReceiveSetError');
    //     const temp = dChainBarCodeDetailsData.shift();
    //     const filterTemp = dChainBarCodeDetailsData.filter(
    //         (item) => item.barCodeNumber !== dchainPopup[0].barCodeNumber
    //     );
    //     console.log('Dchaintemp', temp);
    //     if (filterTemp?.length > 0) {
    //         dChainChangeState(filterTemp[0]);
    //     } else {
    //         dispatch(dChainBarCodeDetails([]));
    //         setDchainPopup([]);
    //     }

    //     setCursorOnInput(true);
    //     if (showSuccessMessageExternalScanner) {
    //         document.getElementById('receivesets-addsetslists-external-barcode-input').value = '';
    //         document.getElementById('receivesets-addsetslists-external-barcode-input').focus();
    //     }
    // };

    // const bulkNotAbleReceiveClose = () => {
    //     // localStorage.removeItem('createReceiveSetError');
    //     const temp = bulkExcludedData.shift();
    //     const filterTemp = bulkExcludedData.filter(
    //         (item) => item.barcode !== notAbleToReceivePopup[0].barcode
    //     );
    //     console.log('Dchaintemp', temp);
    //     console.log('filterTemp', filterTemp);
    //     if (filterTemp?.length > 0) {
    //         notAbleToReceiveState(filterTemp[0]);
    //     } else {
    //         // dispatch(bulkEXcludedPopupData([]));
    //         setNotAbleToReceivePopup([]);
    //     }

    //     setCursorOnInput(true);
    //     if (showSuccessMessageExternalScanner) {
    //         document.getElementById('receivesets-addsetslists-external-barcode-input').value = '';
    //         document.getElementById('receivesets-addsetslists-external-barcode-input').focus();
    //     }
    // };

    if (
        showSuccessMessageExternalScanner &&
        (showNotificationPopup || showInvalidBarcode)
    ) {
        document.getElementById('receivesets-addsetslists-external-barcode-input')?.blur();
    }

    const updateSelectedProduct = (val, reason) => {
        if (val) {
            setOpen(false);
            setSetNumber(val);
            dispatch(SetNumberSelected(val));
            // showMessage(val.cfn);
            const updatedProductList = [...productsList];
            if (
                !updatedProductList.find((product) => val.cfn === product.cfn)
            ) {
                updatedProductList.push({ ...val, quantity: 1 });
                // setProducts(updatedProductList);
            }
        }
        else if(reason==='clear'){
            setOpen(false);
            updateSetNumber('');
            setSelectedProduct('');
            dispatch(
                SetNumberSelected('')
            );
            setSetNumber('');
            setSelectedBatchProduct('');
            dispatch(
                BatchNumberSelected('')
            );
            setBatchNumber('');
            setBatchAdded(!batchAdded);
        }
    };

    const updateBatchSelectedProduct = (val, reason) => {
        if (val) {
            setBatchOpen(false);
            setBatchNum(val);
            setBatchNumber(val);
            dispatch(BatchNumberSelected(val));
            // showMessage(val.cfn);
            const updatedProductList = [...productsList];
            if (
                !updatedProductList.find((product) => val.cfn === product.cfn)
            ) {
                updatedProductList.push({ ...val, quantity: 1 });
                // setProducts(updatedProductList);
            }
        }
        else if(reason==='clear'){
            setBatchNum('');
            setSelectedBatchProduct('');
            dispatch(
                BatchNumberSelected('')
            );
            setBatchNumber('');
        }
    };

    const closeNotificationPopup = () => {
        setShowNotificationPoup(false);
        // setNotAbleToReceivePopup([]);
        setCursorOnInput(true);
        localStorage.removeItem('createReceiveSetError');
        dispatch(resetCreateReceiveSets());
        dispatch(resetBarcodeDetails());
        if (showSuccessMessageExternalScanner) {
            document.getElementById('receivesets-addsetslists-external-barcode-input').value = '';
            document.getElementById('receivesets-addsetslists-external-barcode-input').focus();
        }
    };

    const onSelectItem = (data) => {
        setSelectedProduct(data.cfn);
        dispatch(SetNumberSelected(data.cfn));
        setSelectedProductDesc(data.description);
        setSetNumber(data.cfn);
        setBatchNumber('');
        setSelectedBatchProduct('');
        dispatch(BatchNumberSelected(''));
        setBatchAdded(!batchAdded);
        setSalesOrg(data.salesOrg);
        dispatch(
            getProductDetails({
                productCFN: data.cfn,
                orderType: 'ZLB',
                salesOrg: data.salesOrg,
            })
        );
    };
    const onBatchSelectItem = (data) => {
        setSelectedBatchProduct(data.cfn);
        dispatch(BatchNumberSelected(data.cfn));
        setBatchNumber(data.cfn);
        //setSelectedProductDesc(data.description);
    };
    useEffectWithErrorLogging(() => {
        setAxiosSource(axios.CancelToken.source());
    }, []);
    const debouncedGetList = useRef(
        debounce((getList, option) => {
            getList(option);
        }, 500)
    ).current;
    const autoCompleteInputChange = (e, value, reason) => {
        if (value) {
            updateSetNumber(value);
            if (value?.length >= 3 && reason !== 'reset') {
                setOpen(true);
                debouncedGetList((option) => dispatch(searchProducts(option)), {
                    searchParam: 'productNumber',
                    searchTerm: value,
                    orderType: 'ZLC',
                    cancelSearchToken: axiosSource.token,
                    isTransferSet: true,
                    uhOrder: false,
                });
            }
        }
        else if(reason==='clear'){
            setOpen(false);
            setSelectedProduct('');
            dispatch(
                SetNumberSelected('')
            );
            setSetNumber('');
            setSelectedBatchProduct('');
            dispatch(
                BatchNumberSelected('')
            );
            setBatchNumber('');
            setBatchAdded(!batchAdded);
            setBatchNum('');
        }
    };

    const autoCompleteBatchInputChange = (e, value, reason) => {
        if (value){
            setBatchNum(value);
            if (value?.length >= 3 && reason !== 'reset') {
                setBatchOpen(true);
                debouncedGetList(
                    (option) => dispatch(getProductDetails(option)),
                    {
                        productCFN: selectedProduct,
                        orderType: 'ZLB',
                        salesOrg: salesOrg,
                    }
                );
            }
        }
        else if(reason==='clear'){
             setSelectedBatchProduct('');
            dispatch(
                BatchNumberSelected('')
            );
            setBatchNumber('');
            setBatchNum('');
        }
    };

    if (document.getElementById('receivesets-addsetslists-external-barcode-input')) {
        let barcode = '';
        let interval;
        document.addEventListener('keydown', function (evt) {
            if (interval) {
                clearInterval(interval);
            }
            if (evt.key == 'Enter') {
                if (barcode) handleBarcode(barcode);
                barcode = '';
                return;
            }
            if (evt.key != 'Shift') barcode += evt.key;
            interval = setInterval(() => (barcode = ''), 20);
        });

        const handleBarcode = (scanned_barcode) => {
            document.querySelector('#receivesets-addsetslists-external-barcode-input').innerHTML = scanned_barcode;
        };
    }

    const handleExternalBarcode = (e) => {
        setShowSuccessMessageExternalScanner(true);
        setShowSuccessMessageInScannerScreen(false);
        if (e.target.value?.trim().length >= 12) {
            dispatch(
                getBarcodeReceiveSets({
                    territoryId: territoryId,
                    accountId: accountId,
                    barcode: e.target.value?.trim().replace(/,/g, ''),
                    isManual: true,
                    isBarCode: true,
                    isBulkAdd: false,
                    isExternalBarcode: true,
                })
            );
            document.getElementById('receivesets-addsetslists-external-barcode-input').value = '';
            e.target.value = '';
            // setCursorOnInput(true);
        }
    };

    const scrollFieldToTop = (fieldId) => {
        if (!isMobileView() && !isIpad()) {
            return;
        }

        window.requestAnimationFrame(() => {
            const fieldElement = document.getElementById(fieldId);

            if (fieldElement?.scrollIntoView) {
                fieldElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'nearest',
                });
            }
        });
    };

    // eslint-disable-next-line no-unused-vars
    const handleOnfocus = (event) => {
        setBatchOpen(true);
        setSetFieldFocus(true);
        scrollFieldToTop('receiveSets-receiveSetsLoc-addSets-batch-container');
    };
    // useEffectWithErrorLogging(() => {
    //     {
    //         showDChainStatusPopups?.isInvalid
    //             ? setDChainCrossPlantStatus(true)
    //             : setDChainCrossPlantStatus(false);
    //     }
    // }, [showDChainStatusPopups]);

    return (
        <div>
            <AddSetContainer container direction="row">
                <AddSetScan
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={6}
                    xl={6}
                    mobile={12}
                >
                    <CollapsableCard id="receiveSets-addSetsLists-addSets-addSetScan"
                        title={t(
                            'receiveSets.ReceiveSetsLoc.AddSetsLists.addSetScan'
                        )}
                        onClick={() =>
                            toggleCard(
                                'add_set_scan',
                                !expandedCard.add_set_scan
                            )
                        }
                        isExpanded={expandedCard.add_set_scan}
                        margin={'10px 5px 2px 0px'}
                        mobileMargin={'10px 0 2px 0'}
                        currentActivity
                        titleFontSize={'18px'}
                        fontSizeMobile={'16px'}
                    >
                        {expandedCard.add_set_scan ? (
                            <AddSetScan>
                                <Tabs
                                id="receivesets-addsetslists-scan-tabs"
                                    value={value}
                                    onChange={handleChange}
                                    className={'AddSetTabs'}
                                >
                                    <Tab
                                    id="receivesets-addsetslists-scan-tab-camera"
                                        value="1"
                                        label={t(
                                            'receiveSets.ReceiveSetsLoc.AddSetsLists.camera'
                                        )}
                                        className={'CameraTab'}
                                    />
                                    <Tab
                                      id="receivesets-addsetslists-scan-tab-externalScanner"
                                        value="2"
                                        label={t(
                                            'receiveSets.ReceiveSetsLoc.AddSetsLists.externalScanner'
                                        )}
                                        className={'ExternalScannerTab'}
                                    />
                                </Tabs>
                                {value === '1' && (
                                    <TabContainer>
                                        {counterMessage > 0 && (
                                            <SuccessMsg>
                                                {counterMessage === 1 ? (
                                                    <>
                                                        {counterMessage}{' '}
                                                        {t(
                                                            'receiveSets.ReceiveSetsLoc.AddSetsLists.setAddedToTheListBelow'
                                                        )}
                                                    </>
                                                ) : (
                                                    <>
                                                        {counterMessage}{' '}
                                                        {t(
                                                            'receiveSets.ReceiveSetsLoc.AddSetsLists.setsAddedToTheListBelow'
                                                        )}
                                                    </>
                                                )}{' '}
                                            </SuccessMsg>
                                        )}
                                        <ButtonContainer>
                                            <Button
                                                id={'receiveSets-AddSetsLists-scan-barcode'}
                                                show={true}
                                                //secondary={true}
                                                variant={ButtonStyles?.secondary}
                                                width={
                                                    isLanguageChanged
                                                        ? '215px'
                                                        : '187px'
                                                }
                                                margin={'178px 0 0 auto'}
                                                mobileMargin={'50px 0 0 auto'}
                                                // fontSize={'15px'}
                                                clicked={() =>
                                                    //setScanBarCode(!scanBarCode)
                                                    setShowExteralCameraPopup(
                                                        true
                                                    )
                                                }
                                            >
                                                <div>
                                                    <img
                                                        src={ScanQR}
                                                        style={{
                                                            marginTop: '6px',
                                                        }}
                                                    />
                                                </div>
                                                <TextBold isScan={true}>
                                                    {t(
                                                        'receiveSets.ReceiveSetsLoc.AddSetsLists.scanBarcode'
                                                    )}
                                                </TextBold>
                                            </Button>
                                        </ButtonContainer>
                                    </TabContainer>
                                )}
                                {value === '2' && (
                                    <TabContainer>
                                        <MainContainerItems
                                            id="receiveSets-receiveSetsLoc-addSets-batch-container"
                                            setMarginBottom={true}
                                            isAddSetManually={true}
                                        >
                                            <Title>
                                                {t(
                                                    'receiveSets.ReceiveSetsLoc.AddSetsLists.titleBarCode'
                                                )}
                                            </Title>
                                            <div>
                                                <InputBox
                                                    id="receivesets-addsetslists-external-barcode-input"
                                                    // value={
                                                    //     externalBarcodeNumber
                                                    // }
                                                    placeholder={t(
                                                        'receiveSets.ReceiveSetsLoc.AddSetsLists.selectExternalScanner'
                                                    )}
                                                    width={'90%'}
                                                    // disabled={true}
                                                    onChange={(e) => {
                                                        handleExternalBarcode(e);
                                                    }}
                                                    onPaste={(e) => {
                                                        e.preventDefault();
                                                        const pasted = e.clipboardData.getData('text');
                                                        const InputEvent = { ...e, target: { ...e.target, value: pasted } };
                                                        handleExternalBarcode(InputEvent);
                                                        e.target.value = pasted;
                                                    }}
                                                    autoFocus={
                                                        cursorOnInput && 'on'
                                                    }
                                                />
                                            </div>
                                            {showErrorPopupMessage &&
                                            !showSuccessMessageInScannerScreen ? (
                                                <ErrorMessage>
                                                    {t(
                                                        'receiveSets.ReceiveSetsLoc.AddSetsLists.errorMsg'
                                                    )}
                                                </ErrorMessage>
                                            ) : (
                                                ''
                                            )}
                                            {success &&
                                            !showErrorPopupMessage &&
                                            !showSuccessMessageInScannerScreen ? (
                                                <SuccessMsg
                                                    mbMargin={'15px 0 0 0'}
                                                >
                                                    {t(
                                                        'receiveSets.ReceiveSetsLoc.AddSetsLists.sucessMsg'
                                                    )}
                                                </SuccessMsg>
                                            ) : (
                                                ''
                                            )}
                                        </MainContainerItems>
                                        {/* <ButtonContainer>
                                            <Button
                                                show={true}
                                                width={'125px'}
                                                // margin={'105px 0 0 auto'}
                                                margin={'0 0 0 auto'}
                                                padding={'4px 0'}
                                                fontSize={'15px'}
                                                secondary={
                                                    inputBarcode.length > 0
                                                        ? true
                                                        : false
                                                }
                                                disabled={
                                                    inputBarcode.length > 0
                                                        ? false
                                                        : true
                                                }
                                                clicked={inputBarcodeHandler}
                                            >
                                                <TextBold>
                                                    Add Set to List
                                                </TextBold>
                                            </Button>
                                        </ButtonContainer> */}
                                    </TabContainer>
                                )}
                            </AddSetScan>
                        ) : null}
                    </CollapsableCard>
                </AddSetScan>

                <AddSetManually
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={6}
                    xl={6}
                    mobile={12}
                >
                    <CollapsableCard id="receiveSets-addSetsLists-addSets-addSetManually"
                        title={t(
                            'receiveSets.ReceiveSetsLoc.AddSetsLists.addSetManually'
                        )}
                        onClick={() => {
                            try {
                            toggleCard(
                                'add_set_manually',
                                !expandedCard.add_set_manually
                            );
                             } catch (error) {
                           logErrorToConsole(error);
                        }
                        }}
                        isExpanded={expandedCard.add_set_manually}
                        margin={'10px 0 2px 5px'}
                        mobileMargin={'10px 0 2px 0'}
                        currentActivity
                        titleFontSize={'18px'}
                        fontSizeMobile={'16px'}
                    >
                        {expandedCard.add_set_manually ? (
                            <AddSetScan>
                                {/* <MainContainerItems
                                    setMarginBottom={true}
                                    isAddSetManually={true}
                                >
                                    <Title showAstrisk={true}>Set Number</Title>
                                    <InputBox
                                        placeholder={'Enter Set Number'}
                                        onChange={handleSetInput}
                                    />
                                </MainContainerItems>
                                <MainContainerItems
                                    setMarginBottom={true}
                                    isAddSetManually={true}
                                >
                                    <Title showAstrisk={true}>
                                        Batch Number
                                    </Title>
                                    <InputBox
                                        placeholder={'Enter Batch Number'}
                                        onChange={handleBatchInput}
                                        disabled={
                                            setNo && setNo.length > 0
                                                ? false
                                                : true
                                        }
                                        style={{
                                            background:
                                                setNo && setNo.length > 0
                                                    ? '#ffff'
                                                    : '#F1F1F1',
                                        }}
                                    />
                                </MainContainerItems>
                                <ButtonContainer>
                                    <Button
                                        show={true}
                                        secondary={
                                            setNo.length > 0 &&
                                            batchNo.length > 0
                                                ? true
                                                : false
                                        }
                                        width={'125px'}
                                        margin={'0 0 0 auto'}
                                        padding={'4px 0'}
                                        fontSize={'15px'}
                                        clicked={handleAddSetsToList}
                                        secondaryDisabledBtn={
                                            setNo.length > 0 &&
                                            batchNo.length > 0
                                                ? false
                                                : true
                                        }
                                    >
                                        <TextBold>Add Set to List</TextBold>
                                    </Button>
                                </ButtonContainer> */}
                                <Tabs
                                 id="receivesets-addsetslists-manual-tabs"
                                    value={manualValue}
                                    onChange={handleManualTabChange}
                                    className={'AddSetTabs'}
                                >
                                    <Tab
                                    id="receivesets-addsetslists-manual-tab-setDetails"
                                        value="3"
                                        label={t(
                                            'receiveSets.ReceiveSetsLoc.AddSetsLists.setDetails'
                                        )}
                                        className={'CameraTab'}
                                    />
                                    <Tab
                                    id="receivesets-addsetslists-manual-tab-barcodeNumber"
                                        value="4"
                                        label={t(
                                            'receiveSets.ReceiveSetsLoc.AddSetsLists.barcodeNumber'
                                        )}
                                        className={'ExternalScannerTab'}
                                    />
                                    <Tab
                                     id="receivesets-addsetslists-manual-tab-bulkAddHU"
                                        value="5"
                                        label={t(
                                            'receiveSets.ReceiveSetsLoc.AddSetsLists.bulkAddHU'
                                        )}
                                        className={'ExternalScannerTab'}
                                    />
                                </Tabs>
                                {manualValue === '3' && (
                                    <TabContainer>
                                        <MainContainerItems
                                            setMarginBottom={true}
                                            isAddSetManually={true}
                                        >
                                            <Title showAstrisk={true}>
                                                {t(
                                                    'receiveSets.ReceiveSetsLoc.AddSetsLists.setNumber'
                                                )}
                                            </Title> 
                                            <AutoComplete
                                                inputRef={setNumberRef}
                                                showScrollBar={true}
                                                disableClearable={false}
                                                isFullWidth={true}
                                                options={productsList || []}
                                                value={selectedSetNumber}
                                                inputValue={selectedSetNumber?.cfn?
                                                    selectedSetNumber?.cfn:setNumber?
                                                    setNumber:''
                                                }
                                                clearOnBlur={false}
                                                itemTemplate={(option) => {
                                                    return (
                                                        <AutoListItem
                                                            data={option}
                                                            onSelectItem={
                                                                onSelectItem
                                                            }
                                                            padding={'10px'}
                                                            bBottom={'2px solid #dee2e6'}
                                                        />
                                                    );
                                                }}
                                                
                                                onChange={(val, reason) => {
                                                    updateSelectedProduct(
                                                        val,
                                                        reason
                                                    );
                                                }}
                                                hideNoOptionText={false}
                                                placeholder={t(
                                                            'receiveSets.ReceiveSetsLoc.AddSetsLists.enterSetNumber'
                                                        )}
                                                field="cfn" 
                                                optionValue="cfn"
                                                id={'receiveSets-receiveSetsLoc-addSets-setNumber'}
                                                onInputChange={(
                                                e,
                                                value,
                                                reason
                                                    ) =>
                                                        autoCompleteInputChange(
                                                            e,
                                                            value,
                                                            reason
                                                        )
                                                    }
                                                loading={productsListLoading}
                                                noOptionsText={
                                                    !productsListLoading &&
                                                    productsList?.length === 0
                                                        ? t(
                                                              'calendar.filterResultsPanel.noOptionText'
                                                          )
                                                        : productsListLoading &&
                                                          t(
                                                              'common.loadingText'
                                                          )
                                                }
                                                onFocus={() => {
                                                    try {
                                                    setSetFieldFocus(true);
                                                     } catch (error) {
                                                       logErrorToConsole(error);
                                                     }
                                                }}
                                                onBlur={() => {
                                                    try {
                                                    setSetFieldFocus(false);
                                                     } catch (error) {
                                                         logErrorToConsole(error);
                                                     }
                                                }} 
                                                onOpen={handleOnOpen}
                                                open={selectedSetNumber?.cfn? false :open}
                                                zIndex={99999}
                                                onClose={() => { 
                                                    try {
                                                    setOpen(false); 
                                                     } catch (error) {
                                                         logErrorToConsole(error);
                                                    }
                                                }} 
                                                readOnly={selectedSetNumber?.cfn}
                                                detailsMargin
                                                marginLeft={'1.5px'}
                                                customWidth={'90%'}
                                            />
                                        </MainContainerItems>
                                        <MainContainerItems
                                            setMarginBottom={true}
                                            isAddSetManually={true}
                                        >
                                            <Title showAstrisk={true}>
                                                {t(
                                                    'receiveSets.ReceiveSetsLoc.AddSetsLists.batchNumber'
                                                )}
                                            </Title>
                                            {/* <InputBox
                                                placeholder={
                                                    'Enter Batch Number'
                                                }
                                                value={batchNo}
                                                onChange={handleBatchInput}
                                                disabled={
                                                    selectedProduct &&
                                                    selectedProduct.length > 0
                                                        ? false
                                                        : true
                                                }
                                                style={{
                                                    background:
                                                        selectedProduct &&
                                                        selectedProduct.length >
                                                            0
                                                            ? '#ffff'
                                                            : '#F1F1F1',
                                                }}
                                                width={'90%'}
                                            /> */}
                                            {/* <ReportAutoBatchComplete
                                                className="set-item-search-box"
                                                loading={productsDetailsLoading}
                                                loadingText={t(
                                                    'common.loadingText'
                                                )}
                                               
                                                optionData={
                                                   
                                                }
                                                optionValue={''}
                                                optionLabelKey={'batchNo'}
                                                // inputValue={
                                                //     selectedBatchProduct
                                                // }
                                                value={}
                                                renderInput={(params) => (
                                                    <InputBatchView
                                                        // value={
                                                        //     selectedBatchProduct
                                                        // }
                                                        params={params}
                                                        placeholder={t(
                                                            'receiveSets.ReceiveSetsLoc.AddSetsLists.enterBatchNumber'
                                                        )}
                                                        bgColor={
                                                            selectedProduct.length >
                                                            0
                                                                ? 'unset'
                                                                : '#F1F1F1'
                                                        }
                                                        // onChange={(event) => {
                                                        //     setBatchNumber(
                                                        //         event.target
                                                        //             .value
                                                        //     );
                                                        // }}
                                                    />
                                                )}
                                                renderOption={(option) => {
                                                    return (
                                                        <AutoListBatchItem
                                                            data={option}
                                                            titleField={
                                                                'batchNo'
                                                            }
                                                            onSelectItem={
                                                                onBatchSelectItem
                                                            }
                                                            padding={'10px'}
                                                            key={option}
                                                        />
                                                    );
                                                }}
                                                onInputChange={(
                                                    e,
                                                    value,
                                                    reason
                                                ) =>
                                                    autoCompleteBatchInputChange(
                                                        e,
                                                        value,
                                                        reason
                                                    )
                                                }
                                                
                                                onChange={(_event, newTeam) => {
                                                   
                                                }}
                                               
                                                                                                //onFocus={()=>{setSetFieldFocus(true)}}
                                               
                                                zIndex={99999}
                                                hoverBgColor={'none'}
                                                key={batchAdded}
                                                closeAction={() => {
                                                    setSelectedBatchProduct('');
                                                    dispatch(
                                                        BatchNumberSelected('')
                                                    );
                                                    setBatchNumber('');
                                                }}
                                                closeIconDisplay={
                                                    selectedBatchNumber ===
                                                        '' && 'none'
                                                }
                                            /> */}
                                            <AutoComplete
                                                inputRef={batchRef}
                                                showScrollBar={true}
                                                disableClearable={false}
                                                isFullWidth={true}
                                                options={ result &&
                                                    result != null &&
                                                    result}
                                                value={selectedBatchNumber}
                                                inputValue={selectedBatchNumber?.batchNo?
                                                    selectedBatchNumber?.batchNo:batchNum?
                                                    batchNum:''
                                                }
                                                clearOnBlur={false}
                                                itemTemplate={(option) => {
                                                    return (
                                                        <AutoListBatchItem
                                                            data={option}
                                                            titleField={
                                                                'batchNo'
                                                            }
                                                            onSelectItem={
                                                                onBatchSelectItem
                                                            }
                                                            padding={'10px'}
                                                            key={option}
                                                            bBottom={'2px solid #dee2e6'}
                                                        />
                                                    );
                                                }}
                                                onChange={(val, reason) => { 
                                                    updateBatchSelectedProduct(
                                                        val,
                                                        reason
                                                    );
                                                }}
                                                    disabled={
                                                        selectedProduct.length > 0
                                                            ? !(result && result.length > 0)
                                                            : true
                                                    }
                                                changeBackgroundDisabled={ 
                                                    selectedProduct.length > 0
                                                        ? false
                                                        : true}
                                                hideNoOptionText={false}
                                                placeholder={t(
                                                            'receiveSets.ReceiveSetsLoc.AddSetsLists.enterBatchNumber'
                                                        )}
                                                field="batchNo" 
                                                optionValue="batchNo"
                                                id={'receiveSets-receiveSetsLoc-addSets-batch'}
                                                onInputChange={(
                                                e,
                                                value,
                                                reason
                                                    ) =>
                                                       autoCompleteBatchInputChange(
                                                        e,
                                                        value,
                                                        reason
                                                    )
                                                    }
                                                loading={productsDetailsLoading}
                                                noOptionsText={
                                                    !productsDetailsLoading &&
                                                    result?.length === 0
                                                        ? t(
                                                              'calendar.filterResultsPanel.noOptionText'
                                                          )
                                                        : productsDetailsLoading &&
                                                          t(
                                                              'common.loadingText'
                                                          )
                                                } 
                                                onFocus={(event) =>
                                                    handleOnfocus(event)
                                                }
                                                onOpen={handleBatchOnOpen} 
                                                open={selectedBatchNumber?.batchNo? false :batch}
                                                zIndex={99999}
                                                onClose={() => {
                                                    try {
                                                    setBatchOpen(false);
                                                     } catch (error) {
                                                        logErrorToConsole(error);
                                                     }
                                                }}
                                                onBlur={() => {
                                                    try {
                                                    setSetFieldFocus(false);
                                                    } catch (error) {
                                                        logErrorToConsole(error);
                                                     }
                                                }}
                                                readOnly={selectedBatchNumber?.batchNo}
                                                detailsMargin
                                                marginLeft={'1.5px'}
                                                customWidth={'90%'}
                                            />
                                        </MainContainerItems>
                                        <ButtonContainer>
                                            <Button
                                            id={'receiveSets-AddSetsLists-add-set-to-list'}
                                                show={true}
                                                //secondary={
                                                    // selectedProduct.length &&
                                                    // selectedBatchProduct.length >
                                                    //     0 &&
                                                    // batchNumber ===
                                                    //     selectedBatchProduct &&
                                                    // setNumber ===
                                                    //     selectedProduct
                                                    //     ? true
                                                    //     : false
                                                //     selectedProduct.length >
                                                //         0 &&
                                                //     selectedBatchProduct.length >
                                                //         0
                                                //         ? true
                                                //         : false
                                                // }
                                                width={
                                                    isLanguageChanged
                                                        ? '170px'
                                                        : '125px'
                                                }
                                                margin={'0 0 0 auto'}
                                                padding={'5px 0'}
                                                // fontSize={'15px'}
                                                clicked={handleAddSetsToList}
                                                disabled={
                                                    // selectedProduct.length >
                                                    //     0 &&
                                                    // selectedBatchProduct.length >
                                                    //     0 &&
                                                    // batchNumber ===
                                                    //     selectedBatchProduct &&
                                                    // setNumber ===
                                                    //     selectedProduct
                                                    //     ? false
                                                    //     : true
                                                    selectedProduct.length >
                                                        0 &&
                                                    selectedBatchProduct.length >
                                                        0
                                                        ? false
                                                        : true
                                                }
                                                //ReceiveSets={true}
                                                variant={
                                                    selectedProduct.length > 0 && selectedBatchProduct.length > 0 ? ButtonStyles.secondary : ButtonStyles.disabledReceiveSets}
                                            >
                                                <TextBold>
                                                    {t(
                                                        'receiveSets.ReceiveSetsLoc.AddSetsLists.addSetToList'
                                                    )}
                                                </TextBold>
                                            </Button>
                                        </ButtonContainer>
                                        {showErrorPopupMessage &&
                                        showSuccessMessageInScannerScreen ? (
                                            <ErrorMessage>
                                                {t(
                                                    'receiveSets.ReceiveSetsLoc.AddSetsLists.errorMsg'
                                                )}
                                            </ErrorMessage>
                                        ) : (
                                            ''
                                        )}
                                        {success &&
                                        !showErrorPopupMessage &&
                                        showSuccessMessageInScannerScreen ? (
                                            <SuccessMsg mbMargin={'15px 0 0 0'}>
                                                {t(
                                                    'receiveSets.ReceiveSetsLoc.AddSetsLists.sucessMsg'
                                                )}
                                            </SuccessMsg>
                                        ) : (
                                            ''
                                        )}
                                    </TabContainer>
                                )}
                                {manualValue === '4' && (
                                    <TabContainer>
                                        <MainContainerItems
                                            setMarginBottom={true}
                                            isAddSetManually={true}
                                        >
                                            <Title showAstrisk={true}>
                                                {t(
                                                    'receiveSets.ReceiveSetsLoc.AddSetsLists.barcodeNumber'
                                                )}
                                            </Title>
                                            <InputBox
                                                value={barcodeNo}
                                                id={'receiveSets-AddSetsLists-addSetsLists-barcodeNo'}
                                                placeholder={t(
                                                    'receiveSets.ReceiveSetsLoc.AddSetsLists.enterBarcodeNumber'
                                                )}
                                                width={'90%'}
                                                onChange={handleBarcodeInput}
                                            />
                                        </MainContainerItems>
                                        <ButtonContainer>
                                            <Button
                                            id={'receiveSets-AddSetsLists-add-set-to-list'}
                                                show={true}
                                                // secondary={
                                                //     barcodeNo.length > 0 &&
                                                //     barcodeNo.length > 0
                                                //         ? true
                                                //         : false
                                                // }
                                                disabled={
                                                    barcodeNo &&
                                                    barcodeNo.length > 0
                                                        ? false
                                                        : true
                                                }
                                                variant={barcodeNo.length > 0 && barcodeNo.length > 0 ? ButtonStyles.secondary : ButtonStyles.disabledReceiveSets}
                                                width={
                                                    isLanguageChanged
                                                        ? '170px'
                                                        : '125px'
                                                }
                                                // margin={'95px 0 0 auto'}
                                                margin={'0 0 0 auto'}
                                                padding={'3px 0'}
                                                // fontSize={'15px'}
                                                clicked={handleAddBarcodeToList}
                                                //ReceiveSets={true}
                                            >
                                                <TextBold>
                                                    {t(
                                                        'receiveSets.ReceiveSetsLoc.AddSetsLists.addSetToList1'
                                                    )}
                                                </TextBold>
                                            </Button>
                                        </ButtonContainer>
                                        {showErrorPopupMessage &&
                                        showSuccessMessageInScannerScreen ? (
                                            <ErrorMessage>
                                                {t(
                                                    'receiveSets.ReceiveSetsLoc.AddSetsLists.errorMsg'
                                                )}
                                            </ErrorMessage>
                                        ) : (
                                            ''
                                        )}
                                        {success &&
                                        !showErrorPopupMessage &&
                                        showSuccessMessageInScannerScreen ? (
                                            <SuccessMsg mbMargin={'15px 0 0 0'}>
                                                {t(
                                                    'receiveSets.ReceiveSetsLoc.AddSetsLists.sucessMsg'
                                                )}
                                            </SuccessMsg>
                                        ) : (
                                            ''
                                        )}
                                    </TabContainer>
                                )}
                                {manualValue === '5' && (
                                    <TabContainer>
                                        <Title>
                                            {t('receiveSets.addOrPastInBulk')}
                                        </Title>
                                        <TextAreaContainer>
                                            <TextArea
                                            id="receivesets-addsetslists-bulk-textarea"
                                                height={editableHeight}
                                                value={bulkValues}
                                                onChange={(e) =>
                                                    setBulkValues(
                                                        e.target.value
                                                    )
                                                }
                                                placeholder={t(
                                                    'receiveSets.pastePlaceHolderText'
                                                )}
                                            ></TextArea>
                                        </TextAreaContainer>
                                        <StyledDiv>
                                            {`${
                                                bulkValues
                                                    .split('\n')
                                                    .map((element) =>
                                                        element
                                                            .replace(
                                                                /[\r\n]+/gm,
                                                                ''
                                                            )
                                                            .trim()
                                                    )
                                                    .filter(
                                                        (item) =>
                                                            item.length > 0
                                                    ).length
                                            }` >= 1 && (
                                                <p
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#000000',
                                                        margin: '0',
                                                        fontFamily:
                                                            'AvenirNextWorld Regular',
                                                        opacity: '1',
                                                    }}
                                                >
                                                    {`${
                                                        bulkValues
                                                            .split('\n')
                                                            .map((element) =>
                                                                element
                                                                    .replace(
                                                                        /[\r\n]+/gm,
                                                                        ''
                                                                    )
                                                                    .trim()
                                                            )
                                                            .filter(
                                                                (item) =>
                                                                    item.length >
                                                                    0
                                                            ).length
                                                    } lines`}
                                                </p>
                                            )}
                                        </StyledDiv>
                                        <ButtonsContainer>
                                            <Button
                                            id={'receiveSets-AddSetsLists-copy-to-clipboard'}
                                                show
                                                // secondary
                                                variant={ButtonStyles?.secondary}
                                                width={'84px'}
                                                height={'38px'}
                                                margin={'0px 9px 0px 0px'}
                                                clicked={copyToClipBoard}
                                                // fontSize={'15px'}
                                            >
                                                {t('receiveSets.paste')}
                                            </Button>
                                            <Button
                                            id="receivesets-addsetslists-clear-button"
                                                show
                                                // secondary
                                                variant={ButtonStyles?.secondary}
                                                width={'84px'}
                                                height={'38px'}
                                                margin={'0px 9px 0px 0px'}
                                                clicked={
                                                    openDiscardPopup
                                                    //     () => {
                                                    //     setBulkValues('');
                                                    //     resetPosition();
                                                    // }
                                                }
                                                // fontSize={'15px'}
                                            >
                                                {t('common.clearButton')}
                                            </Button>
                                            <Button
                                            id={'receiveSets-AddSetsLists-add-bulk-to-list'}
                                                show
                                                // disabled={bulkValues.length < 1}
                                                // primary={bulkValues.length > 0}
                                                variant={bulkValues.length > 0 ? ButtonStyles.primary : ButtonStyles.disabled}
                                                width={'120px'}
                                                height={'38px'}
                                                margin={'0px 9px 0px 0px'}
                                                clicked={addBulkToList}
                                                // fontSize={'15px'}
                                            >
                                                {t('receiveSets.addTolistText')}
                                            </Button>
                                        </ButtonsContainer>
                                        {showErrorPopupMessage &&
                                        showSuccessMessageInScannerScreen ? (
                                            <ErrorMessage>
                                                {t(
                                                    'receiveSets.ReceiveSetsLoc.AddSetsLists.errorMsg'
                                                )}
                                            </ErrorMessage>
                                        ) : (
                                            ''
                                        )}
                                        {success &&
                                        !showErrorPopupMessage &&
                                        showSuccessMessageInScannerScreen ? (
                                            <SuccessMsg mbMargin={'15px 0 0 0'}>
                                                {t(
                                                    'receiveSets.ReceiveSetsLoc.AddSetsLists.sucessMsg'
                                                )}
                                            </SuccessMsg>
                                        ) : (
                                            ''
                                        )}
                                    </TabContainer>
                                )}
                                {showDiscardPopup ? (
                                    <UnsavedChanges
                                    id="receivesets-addsetslists-unsavedchanges-popup"
                                        onDiscard={handleDiscardChanges}
                                        onClose={() =>
                                            setPopupDetails({
                                                ...popupDetails,
                                                showDiscardPopup: false,
                                                id: null,
                                            })
                                        }
                                    />
                                ) : null}
                            </AddSetScan>
                        ) : null}
                    </CollapsableCard>
                </AddSetManually>
            </AddSetContainer>
            {scanBarCode ? (
                <ScanBardCodePopUp
                    scanBarCode={scanBarCode}
                    setScanBarCode={setScanBarCode}
                    accountId={accountId}
                    territoryId={territoryId}
                    counter={counter}
                    setCounter={setCounter}
                    counterMessage={counterMessage}
                    setCounterMessage={setCounterMessage}
                />
            ) : null}
            {showInvalidBarcode && <InvalidBarcodePopup id="receivesets-addsetslists-invalidbarcode-popup" onClose={popupClose} />}
            {isBulkDchainAdd
                ? bulkPopups.length > 0
                    ? bulkPopups?.map((item, id) =>
                          item?.validatedData ? (
                              <NotAbleToReceiveSets
                              id="receivesets-addsetslists-notabletoreceivesets-popup"
                                  key={id}
                                  onClose={bulkPopupClose}
                                  setNumber={item?.sets[0].setNo}
                                  batchNumber={item?.sets[0].batchNo}
                                  isManual={true}
                                  BulkValidatedData={item?.validatedData}
                                  isBulkDchainAdd={isBulkDchainAdd}
                              />
                          ) : item?.statusCode === '11911' ? (
                              <InvalidBarcodePopup
                              id="receivesets-addsetslists-bulk-invalidbarcode-popup"
                                  key={id}
                                  validate={item?.setNumber}
                                  onClose={bulkPopupClose}
                              />
                          ) : (
                              <InvalidBarcodePopup
                              id="receivesets-addsetslists-bulk-general-invalidbarcode-popup"
                                  key={id}
                                  barcode={
                                      item?.barCodeNumber || item?.setNumber
                                  }
                                  onClose={bulkPopupClose}
                              />
                          )
                      )
                    : null
                : null}
            {!isBulkDchainAdd
                ? showNotificationPopup && (
                      <NotAbleToReceiveSets
                      id="receivesets-addsetslists-single-notabletoreceivesets-popup"
                          onClose={closeNotificationPopup}
                          setNumber={
                              validatedData?.isManual
                                  ? barcodeDetails?.setNumber
                                  : validatedData?.setNo
                          }
                          batchNumber={
                              validatedData?.isManual
                                  ? barcodeDetails?.batchNumber
                                  : validatedData?.batchNo
                          }
                          isManual={true}
                      />
                  )
                : null}
            {/* {dchainPopup.length > 0
                ? dchainPopup?.map((item, id) => (
                      <InvalidBarcodePopup
                          key={id}
                          //   content={item?.setNumber}
                          validate={item?.setNumber}
                          onClose={bulkDchainPopupClose}
                      />
                  ))
                : null} */}
            {dChainCrossPlantStatus && (
                <InvalidBarcodePopup
                id="receivesets-addsetslists-dchain-crossplant-invalidbarcode-popup"
                    onClose={popupClose}
                    // content={barcodeDetails?.setNumber}
                    validate={validatedData?.setNo}
                />
            )}
            {showExteralCameraPopup && (
                <ExternalCamera
                id="receivesets-addsetslists-externalcamera-popup"
                    onClose={() => setShowExteralCameraPopup(false)}
                    onOpen={() => {
                        try {
                        setShowExteralCameraPopup(false);
                        setCounter(0); // Reset counter when opening scanner
                        dispatch(resetCreateReceiveSets()); // Clear old validation data
                        setScanBarCode(true);
                        } catch (error) {
                           logErrorToConsole(error);
                        }
                    }}
                />
            )}
            {receiveSetsLoading && (
                <Backdrop
                    showCloseButton={false}
                    showBackdrop={true}
                    isModal
                    loaderBackground
                >
                    <Spinner id="receiveSets-addSetsLists-backdrop-loadingSpinner" animation="border" variant="primary" small />
                </Backdrop>
            )}
        </div>
    );
}
